import React from "react";
import { AlertSvg, ErrorSvg } from "./../styles";

const ErrorCode = [100, 105];

export const AlertIcon = () => {
  return (
    <AlertSvg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.6323 51.0271C92.6323 74.2814 73.5457 93.1324 50.0007 93.1324C26.4558 93.1324 7.36914 74.2814 7.36914 51.0271C7.36914 27.7729 26.4558 8.92188 50.0007 8.92188C73.5457 8.92188 92.6323 27.7729 92.6323 51.0271ZM10.4512 51.0264C10.4512 72.5995 28.1582 90.0879 50.0009 90.0879C71.8437 90.0879 89.5507 72.5995 89.5507 51.0264C89.5507 29.4532 71.8437 11.9648 50.0009 11.9648C28.1582 11.9648 10.4512 29.4532 10.4512 51.0264ZM49.0797 55.7705C49.495 56.1094 49.9717 56.2794 50.5078 56.2794C51.0981 56.2794 51.601 56.1033 52.0163 55.7502C52.4317 55.397 52.667 54.882 52.7203 54.2032L53.203 40.6876C53.2302 40.1716 53.2433 39.8195 53.2433 39.6292V39.1407C53.2433 38.1637 53.015 37.4441 52.5594 36.9831C52.1038 36.522 51.4461 36.291 50.5882 36.291C49.6499 36.291 48.952 36.5485 48.4964 37.0645C48.0408 37.5805 47.8125 38.3133 47.8125 39.2628V39.6903C47.8125 39.8663 47.8256 40.1991 47.8527 40.6876L48.3757 54.2032C48.429 54.9085 48.6643 55.4316 49.0797 55.7705ZM48.234 64.7679C48.8103 65.4325 49.5686 65.7653 50.5069 65.7653C51.4452 65.7653 52.2096 65.4325 52.7999 64.7679C53.3903 64.1033 53.6849 63.2952 53.6849 62.3457C53.6849 61.4226 53.3903 60.6288 52.7999 59.9642C52.2096 59.2996 51.4452 58.9668 50.5069 58.9668C49.5686 58.9668 48.8103 59.2996 48.234 59.9642C47.6578 60.6288 47.3691 61.4226 47.3691 62.3457C47.3691 63.2952 47.6578 64.1033 48.234 64.7679Z"
        fill="currentColor"
      />
    </AlertSvg>
  );
};

export const ErrorIcon = () => {
  return (
    <ErrorSvg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.2613 8.9209C27.1912 8.9209 8.42102 27.6895 8.42102 50.7612C8.42102 73.8329 27.1912 92.6015 50.2613 92.6015C73.3314 92.6015 92.1016 73.8329 92.1016 50.7612C92.1016 27.6895 73.3314 8.9209 50.2613 8.9209ZM39.232 36.7685L39.3673 36.89L50.3789 47.6683L61.1429 36.9059C61.9651 36.0838 63.298 36.0838 64.1202 36.9059C64.8991 37.6848 64.9401 38.9222 64.2432 39.7493L64.1202 39.8832L53.3894 50.6135L64.1041 61.1005C64.9351 61.9138 64.9494 63.2467 64.1361 64.0777C63.3657 64.8649 62.1288 64.9192 61.2942 64.2312L61.159 64.1097L50.4115 53.5914L39.9097 64.0938C39.0875 64.9159 37.7545 64.9159 36.9324 64.0938C36.1535 63.3149 36.1125 62.0775 36.8094 61.2504L36.9324 61.1165L47.4021 50.6451L36.4222 39.8991C35.5912 39.0859 35.5769 37.753 36.3901 36.922C37.1178 36.1785 38.2615 36.0888 39.0894 36.6607L39.232 36.7685ZM11.546 50.7612C11.546 72.1078 28.9147 89.4765 50.2613 89.4765C71.6079 89.4765 88.9766 72.1078 88.9766 50.7612C88.9766 29.4145 71.6079 12.0459 50.2613 12.0459C28.9147 12.0459 11.546 29.4145 11.546 50.7612Z"
        fill="currentColor"
      />
    </ErrorSvg>
  );
};

export const SetIconByCode = (code: string | null) => {
  if (!code || ErrorCode.includes(parseInt(code))) {
    return <ErrorIcon />;
  }
  return <AlertIcon />;
};
